import { Suspense, useContext } from 'react';
import { useRemoteComponent } from 'zf-web-components';
import { RootContext } from '@stores';
import { useApp } from '../../hooks';
import { getRemoteUrl } from './util';


export function ToolsMenu(): JSX.Element {
  const { app } = useApp();
  const remote = getRemoteUrl(app);

  const { Component: LazyToolsMenu } = useRemoteComponent<{ tenantName?: string; name?: string }>(remote as string, 'ToolsMenu');

  const root = useContext(RootContext);
  const { user } = root;

  return (
    <Suspense fallback={<></>}>
      {LazyToolsMenu != null && <LazyToolsMenu tenantName={user?.tenantName} name={user?.name} />}
    </Suspense>
  );
}
